//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {scrollToSelector} from "spoferan-ui/src/helpers/html_helpers";

export default {
    data() {
        return {
            jobs: [],
            params: {club: 11, category: '_clubs', relations: ['category']}
        }
    },

    methods: {
        scrollToContent() {
            scrollToSelector('#overview')
        }
    }
}
